import React from 'react';

const List = () => {

	return (
			<h1>hello from list</h1>
		);
};

export default List;